import { isDefined } from "../../helpers";
export default function (store, { id, batchID, $meta }) {
    const task = store.getTask(id);
    const parent = store.getTask(task?.parent);
    if (!isDefined(parent?.id))
        return;
    store.in.exec("move-task", {
        id,
        parent: parent.parent ?? null,
        targetId: parent.id,
        operation: "unindent",
        batchID,
        $meta,
    });
}
//# sourceMappingURL=unindent.js.map